/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const updateRoleBodyExpectedVersionExclusiveMin = 0;
export const updateRoleBodyExpectedVersionMax = 9007199254740991;

export const UpdateRoleBody = zod.object({
  role: zod.union([zod.enum(['Agent', 'Admin']), zod.null()]),
  expectedVersion: zod
    .int()
    .gt(updateRoleBodyExpectedVersionExclusiveMin)
    .max(updateRoleBodyExpectedVersionMax),
});

export type UpdateRoleBody = zod.input<typeof UpdateRoleBody>;
export type UpdateRoleBodyOutput = zod.output<typeof UpdateRoleBody>;
